import { FC } from 'react';
import { addDays, format, startOfWeek } from 'date-fns';
import classNames from 'classnames';

interface IProps {
  activeDate: Date;
}

const WeekDaysNames: FC<IProps> = ({ activeDate }) => {
  const weekStartDate = startOfWeek(activeDate, { weekStartsOn: 1 });
  const weekDays = [];
  for (let day = 0; day < 7; day++) {
    const weekDay = format(addDays(weekStartDate, day), 'EEEEEE');
    weekDays.push(
      <div
        key={weekDay}
        className={classNames(
          'event-calendar__day-cell',
          'event-calendar__week-days-names',
        )}
      >
        {weekDay}
      </div>,
    );
  }
  return (
    <div className={classNames('event-calendar__week-days-names-container')}>
      {weekDays}
    </div>
  );
};

export default WeekDaysNames;
